import { Component, Inject, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { InputModalModel } from '@shared/models'
import { FormHelperService } from '@widgets/form/services/form-helper.service'

@Component({
  templateUrl: './input.component.html',
})
export class InputComponent implements OnInit {
  title: string
  message: string
  primaryOption: string
  secondaryOption: string
  label: string
  form: FormGroup
  validator: any
  primaryOptionColor: string
  mask: string
  constructor(@Inject(MAT_DIALOG_DATA) data, private formHelper: FormHelperService) {
    this.title = data.title
    this.message = data.message
    this.primaryOption = data.primaryOption
    this.secondaryOption = data.secondaryOption
    this.label = data.label
    this.validator = data.validator
    this.primaryOptionColor = data.primaryOptionColor
    this.mask = data.mask
  }
  ngOnInit(): void {
    this.form = this.formHelper.createForm<InputModalModel>(
      {
        input: '',
      },
      {
        input: null,
      }
    )
  }
  get control() {
    return this.form.controls.input as FormControl
  }
}
